import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=744a7547"
import script from "./Messages.vue?vue&type=script&lang=ts"
export * from "./Messages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports